module.exports = __webpack_public_path__ + "img/15_19.83cebffe.png";